/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_MembershipInputs */

const en_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memberships`)
};

const de_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaften`)
};

const es_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membresías`)
};

const fr_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adhésions`)
};

const nl_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidmaatschappen`)
};

const it_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonamenti`)
};

const pt_br2_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assinaturas`)
};

const pl_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Członkostwa`)
};

const hu_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagságok`)
};

const ro_admin_dashboard_invoice_tags_membership = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonamente`)
};

/**
* | output |
* | --- |
* | "Memberships" |
*
* @param {Admin_Dashboard_Invoice_Tags_MembershipInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_membership = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_MembershipInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_MembershipInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_membership(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_membership(inputs)
	return ro_admin_dashboard_invoice_tags_membership(inputs)
});
export { admin_dashboard_invoice_tags_membership as "admin.dashboard.invoice_tags.membership" }